import React, { useEffect } from 'react';

interface SettingsSaveModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoggedIn: boolean;
}

const SettingsSaveModal: React.FC<SettingsSaveModalProps> = ({ isOpen, onClose, isLoggedIn }) => {
  useEffect(() => {
    if (isOpen) {
      // Auto-close after 3 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const getHumorMessage = () => {
    if (!isLoggedIn) {
      return "you do realize ur not whitelisted yet, right? these settings won't do anything lmao.";
    }
    
    // Random sarcastic messages for whitelisted users
    const messages = [
      "settings saved! not that it matters much.",
      "congrats, u changed some numbers. very impressive.",
      "settings saved. ur still gonna get banned though.",
      "saved! now maybe u can pretend to be productive.",
      "settings updated. dork is still judging u tho."
    ];
    
    return messages[Math.floor(Math.random() * messages.length)];
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-black border-2 border-white p-6 max-w-md mx-4 text-center settings-modal pointer-events-auto">
        <div className="text-3xl mb-3 text-green-400">
          <i className="fa-solid fa-check-circle"></i>
        </div>
        <h3 className="text-lg font-bold text-white mb-2">settings saved!</h3>
        <p className="text-sm text-gray-400 mb-4">
          {getHumorMessage()}
        </p>
        <div className="w-full bg-gray-700 h-1 rounded">
          <div 
            className="bg-white h-1 rounded progress-bar" 
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSaveModal;